import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistDocument } from "../../Persist/AbstractDocumentPersister";
import { stageMetaDataDocument } from "../../Stages/StagesDocument";
import * as documentStages from "../../Stages/StagesDocument";
import * as documentStatus from "../../LeadStatus/StatusDocument";
import documentTransformations from "../FormTransformations/documentTransformations";
import { stageFormDefinition as stageFormDefinitionDocument } from "../FormDefinitions/document";
import { fullFormDefinition as fullFormDefinitionPowerOfAttorney } from "../FormDefinitions/powerOfAttorney";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";

export const powerOfAttorney: ProductData = {
  urlPart: "vorsorgevollmacht",
  lbUrlPart: "vorsorgevollmacht",
  label: translate("powerOfAttorney.label"),
  generalLabel: translate("powerOfAttorney.label"),
  apiUri: "power_of_attorneys",
  persist: persistDocument,
  stages: stageMetaDataDocument,
  stageConstants: documentStages,
  minimumCaseStatus: documentStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: documentStages.STAGE_INCOMPLETE,
  setBackCaseStage: documentStages.STAGE_READY,
  paymentType: {
    creditcard: "Kreditkarte",
    paypal: "Paypal",
    sofort: "Sofortüberweisung",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\Document\\PowerOfAttorney",
  formTransformations: documentTransformations,
  formDefinition: ({ product }) => stageFormDefinitionDocument(product.productClassName),
  formDefinitionExternals: () => [],
  fullFormDefinition: () => fullFormDefinitionPowerOfAttorney,
  productSpecificDefinition: () => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.powerOfAttorney,
}
